import { useCallback, useMemo } from 'react';

import * as yup from 'yup';

import type { IValidationFields } from './types';
import * as validationSchemas from './validationSchemas';

const useValidations = () => {
  const createSchema = useCallback((fields: IValidationFields) => {
    const validations = {};
    for (const field of fields) {
      let schema = field.schema || validationSchemas[field.type] || yup.mixed();

      if (typeof schema === 'function') {
        schema = schema(field);
      }
      if (!validationSchemas[field.type])
        console.error(`Undefined validation type: ${field.type} `);

      // Extend field schema
      if (field.extendSchema) {
        schema = field.extendSchema(schema);
      }

      validations[field.ruleName || field.type] = schema;
    }

    return yup.object().shape(validations);
  }, []);

  return useMemo(() => ({ createSchema }), [createSchema]);
};
export default useValidations;
